// extracted by mini-css-extract-plugin
export var alternate = "_f-j";
export var black = "_f-6";
export var blue = "_f-f";
export var blueLight = "_f-e";
export var brand = "_f-8";
export var darkMode = "_f-b";
export var error = "_f-a";
export var gray = "_f-5";
export var grayBlue = "_f-d";
export var iconWrapper = "_f-3";
export var inactive = "_f-7";
export var indigo = "_f-g";
export var orange = "_f-i";
export var pink = "_f-h";
export var primary = "_f-0";
export var purple = "_f-9";
export var success = "_f-4";
export var warning = "_f-c";
export var white = "_f-1";
export var whiteSuccess = "_f-2";